module.exports = __webpack_public_path__ + "static/media/main-bg.f4e93ad3.jpg";